import { PageMeta } from '../components/seo/PageMeta'
import { Hero } from '../components/home/Hero'
import { ProblemSection } from '../components/home/ProblemSection'
import { TwoPillars } from '../components/home/TwoPillars'
import { SpectraSection } from '../components/home/SpectraSection'
import { ProcessSteps } from '../components/home/ProcessSteps'
import { Calculator } from '../components/home/Calculator'
import { Testimonials } from '../components/home/Testimonials'
import { Industries } from '../components/home/Industries'
import { FounderSection } from '../components/home/FounderSection'
import { CtaSection } from '../components/home/CtaSection'
import { pageMeta } from '../lib/seo'
import { localBusinessSchema } from '../lib/schema'

export default function Home() {
  return (
    <>
      <PageMeta
        title={pageMeta.home.title}
        description={pageMeta.home.description}
        canonical={pageMeta.home.canonical}
        schema={localBusinessSchema}
      />
      <Hero />
      <ProblemSection />
      <TwoPillars />
      <SpectraSection />
      <ProcessSteps />
      <div className="calculator-wrapper" suppressHydrationWarning>
        <Calculator />
      </div>
      <Testimonials />
      <Industries />
      <FounderSection />
      <CtaSection />
    </>
  )
}
